import React from 'react'
import { connect } from 'react-redux'
import { Grid, Segment, Menu } from 'semantic-ui-react'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import dateComparer from 'loankeeper-common/helpers/dateComparer'
import { LKHeader, LKIcon } from 'loankeeper-common/components'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import { FakeInput, GridContainer, SegmentGroup, FlexTableChild, TableContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import { colors } from 'shared'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { actions as DCActions, constants as DCConstants } from '../../DetailsContainer'
import { translateLabel, translateCmd, translateBase, translateLKMessage, icon } from '../helpers'
import { formName } from '../constants'
import IDDocModal, { MODAL_NAME as IDDOC_MODAL } from './IDDocModal'
import { PhysicalThirdTabProps, ContextMenuDataTypes } from '../types'
import { ClientDeleteIdDocParams } from '@lk/api'
import { clinetDeleteIdDoc } from 'src/store/client'
import { AppDispatch } from 'src/store/index.d'

const getConfig = (openIdDocEdit, openIdDocDelete) => {
  return {
    gridIdentity: { formName, objectName: 'dbgrd_iddocs' },
    columnConfigs: {
      CDate: { valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
      IssueDate: { comparator: dateComparer, valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
      ExpireDate: { comparator: dateComparer, valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
      Active: { iconComponent: (value: number) => (value !== 0 ? 'ok' : 'cancel') },
    },
    enableColumnsResize: true,
    enableColumnsOrder: true,
    enableColumnsHide: false,
    enableSorting: false,
    enableTranslate: true,
    enableRowSelection: true,
    syncGridState: true,
    getRowStyle: ({
      node: {
        data: { Active },
      },
    }) => {
      if (Active === 0) {
        return { color: colors.grey }
      }
      return {}
    },
    getContextMenuItems: ({ node: { data } }: { node: { data: ContextMenuDataTypes } }) => [
      {
        name: translateCmd('iddoc_view'),
        action: () => openIdDocEdit(data, true),
        icon: 'info',
        permissionKey: 'CLIENT_VIEW_IDDOC',
      },
      {
        name: translateCmd('iddoc_edit'),
        action: () => openIdDocEdit(data),
        icon: 'edit',
        permissionKey: 'CLIENT_EDIT_IDDOC',
      },
      {
        name: translateCmd('iddoc_delete'),
        action: () => openIdDocDelete(data),
        icon: 'delete',
        permissionKey: 'CLIENT_DELETE_IDDOC',
      },
      'excelExport',
    ],
  }
}

const IDDOC_DELETE_MODAL = 'IDDocDeleteModal'
@withConstantPermissions()
//@ts-ignore
@connect(undefined, {
  openIdDocModal: (view: boolean, data?: any) => LKModalActions.open({ name: IDDOC_MODAL, data, view }),
  openIdDocDelete: (modalParams: ContextMenuDataTypes) =>
    LKModalActions.openConfirmation(IDDOC_DELETE_MODAL, modalParams),
  openErrorModal: (message: string) => LKModalActions.openError(message),
  fetchPage: (ID: string, hash: string) =>
    DCActions.fetchPage({
      type: 'Client',
      ID,
      hash,
      page: 'iddocs',
    }),
})
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => ({
  clinetDeleteIdDoc: (params: ClientDeleteIdDocParams) => dispatch(clinetDeleteIdDoc(params)),
}))
class PhysicalThird extends React.Component<PhysicalThirdTabProps> {
  openIdDocEdit = (data: ContextMenuDataTypes, view = false) => {
    this.props.openIdDocModal(view, data)
  }

  openIdDocDelete = (data: ContextMenuDataTypes) => {
    this.props.openIdDocDelete(data)
  }

  config = getConfig(this.openIdDocEdit, this.openIdDocDelete)

  deleteIdDoc = async (data: ContextMenuDataTypes) => {
    // try {
    //   await Client.deleteIdDoc({ hash: this.props.hash, ...data })
    //   this.props.fetchPage(this.props.ID, this.props.hash)
    // } catch (e) {
    //   this.props.openErrorModal(translateLKMessage(`${e.Error.Message || e.Error.Text}`))
    // }

    //UPDATED API REQUEST client_oper_api page: iddocdelete
    try {
      const res = await this.props.clinetDeleteIdDoc({
        HashSum_ClientID_: this.props.hash,
        ID: data.ID,
        ClientID: data.ClientID,
      })
      if (clinetDeleteIdDoc.fulfilled.match(res)) {
        this.props.fetchPage(this.props.ID, this.props.hash)
      } else if (clinetDeleteIdDoc.rejected.match(res)) {
        this.props.openErrorModal(translateLKMessage(res.payload as string))
      }
    } catch (error) {
      this.props.openErrorModal(translateLKMessage(`${error?.Error?.Message || error?.Error?.Text}`))
    }
  }

  openIdDocAdd = () => {
    this.props.openIdDocModal(false)
  }

  render() {
    const {
      ID,
      hash,
      data: { base, iddocs, linkedfiles },
      permissions,
    } = this.props

    return (
      <SegmentGroup>
        <Segment.Group horizontal className="u-flex u-fluid" style={{ margin: '5px' }}>
          <Segment className="u-flex u-fluid u-directionColumn">
            <Menu attached="top">
              <Menu.Item className="u-noPadding u-paddingRight-15 u-paddingLeft-5">
                <LKIcon alias="hrm_details" size={30} style={{ marginRight: 5 }} />

                {translateBase('grp_iddocs')}
              </Menu.Item>
            </Menu>

            <FlexTableChild>
              <TableContainer>
                <LKGrid
                  {...this.config}
                  instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-IDDocs`}
                  rowData={iddocs}
                />
              </TableContainer>
            </FlexTableChild>

            <div className="u-padding-5">
              {permissions.CLIENT_ADD_IDDOC && (
                <LKButton onClick={this.openIdDocAdd} alias="add" size="tiny" permission="">
                  {translateCmd('iddoc_add')}
                </LKButton>
              )}
              <IDDocModal ID={ID} hash={hash} client={base} linkedfiles={linkedfiles} />
              <LKModal.Confirmation name={IDDOC_DELETE_MODAL} onConfirm={this.deleteIdDoc} />
            </div>
          </Segment>

          <Segment className="u-fluid">
            <GridContainer paddingLeftRight>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('family_total_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.FamilyMembers}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('femalefamily_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.FemaleFamilyMembers}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('children_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.Children}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('oldfamily_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.OldFamily}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('dependants_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.Dependants}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('femaledependants_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.FemaleDependants}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('idpdependats_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.IDPDependants}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('invalidfamily_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.InvalidFamily}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('employees_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.Employed}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('femalefamily_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.FemaleEmployed}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row verticalAlign="middle">
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('idpemployees_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.IDPEmployed}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row verticalAlign="middle">
                  <Grid.Column width={8} textAlign="right">
                    {translateLabel('family_members_bus_t')}
                  </Grid.Column>

                  <Grid.Column width={8}>
                    <FakeInput>
                      <Segment>
                        <LKHeader size="small">{base.IND_FamilyMembers_Bus}</LKHeader>
                      </Segment>
                    </FakeInput>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          </Segment>

          <Segment className="u-fluid" />
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

//@ts-ignore
PhysicalThird.config = {
  title: () => translateBase('tb_ind_3'),
  name: 'general2',
  component: PhysicalThird,
  api: ['base', 'iddocs', 'linkedfiles'],
  icon: icon('tb_ind_3'),
}

//@ts-ignore
PhysicalThird.defaultProps = {
  data: {},
}

export default PhysicalThird
